import axios from 'axios';
import { useAuthStore } from '@/stores/auth';

let API_URL, BRAND_API_URL, STOCKAPI_URL;

if (['https://omarket.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://web1.omarket.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_API1_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;

} else if (['https://web2.omarket.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_API2_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://web3.omarket.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_API3_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://shcolab.co.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_SHCOLAB_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://daenlabs.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_DAENLABS_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://kimmanager.co.kr', 'https://api.kimmanager.co.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_KIMMANAGER_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://web3.omarket.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_API3_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://kcode.store'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_KCODE_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://connectone07.co.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_WITHJIKKOO_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://crosssell.co.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_CROSSSELL_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://overlink.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_OVERWAY_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_OVERWAY_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://app.overlink.kr'].includes(window.location.origin)) {
  API_URL = 'https://apiv2.omarket.kr/api';
  STOCKAPI_URL = process.env.VUE_APP_STOCK_OVERWAY_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://stock.overlink.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_STOCK_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_PRODUCT_STOCK_API_URL;
  BRAND_API_URL = process.env.VUE_APP_BRAND_PRODUCT_API_URL;
} else if (['https://zijyasssssell.com'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_ZIJYASSSSSELL_API_URL;

} else if (['https://osonupload.com'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_OSONUPLOAD_API_URL;
  STOCKAPI_URL = process.env.VUE_APP_STOCK_CROSSSELL_API_URL;

} else if (['https://smartcross.kr'].includes(window.location.origin)) {
  API_URL = process.env.VUE_APP_PRODUCT_SMARTCROSS_API_URL;

} else {
  API_URL = process.env.VUE_APP_TEST_API_URL;

}

/**
 * 마케팅 API 베이스 URL.
 * Vue CLI는 빌드 시점에만 VUE_APP_* 를 치환하므로, 미주입 시 undefined 가 되어
 * 요청이 localhost:8080/app/undefined/Collect/... 로 가는 문제가 난다.
 * 우선순위: 테스트 전용 → 공용 마케팅 URL → 로컬 호스트일 때 기본값
 */
function resolveMarketingApiBaseUrl() {
  const isLocal =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocal) {
    const testUrl = process.env.VUE_APP_TEST_MARKETTING_API_URL;
    if (testUrl && String(testUrl).trim()) {
      return String(testUrl).replace(/\/+$/, '');
    }
    return 'https://localhost:5007';
  }

  return 'https://ad.overlink.kr';
}

const MARKETING_API_URL = resolveMarketingApiBaseUrl();

export const JwtAxios = {
  get: request('GET', API_URL),
  post: request('POST', API_URL),
  delete: request('DELETE', API_URL),
  put: request('PUT', API_URL),
  patch: request('PATCH', API_URL),
  download: request('DOWNLOAD', API_URL),
  upload: multipartUpload('POST', API_URL),
  excelMultiPartGet: multipartRequest('GET', API_URL),
  excelMultiPartPost: multipartRequest('POST', API_URL),
  getBlob: (path, params) => {
    const url = API_URL + path;
    const requestOptions = {
      headers: authHeader(),
      params
      /*     responseType: 'blob'*/
    };
    return axios
      .get(url, requestOptions)
      .then(handleResponse)
      .catch(handleError);
  }
};

export const MarketingJwtAxios = {
  get: request('GET', MARKETING_API_URL),
  post: request('POST', MARKETING_API_URL)
};

export const StockJwtAxios = {
  get: request('GET', STOCKAPI_URL),
  post: request('POST', STOCKAPI_URL),
  delete: request('DELETE', STOCKAPI_URL),
  put: request('PUT', STOCKAPI_URL),
  patch: request('PATCH', STOCKAPI_URL),
  download: request('DOWNLOAD', STOCKAPI_URL),
  upload: multipartUpload('POST', STOCKAPI_URL),
  excelMultiPartGet: multipartRequest('GET', STOCKAPI_URL),
  excelMultiPartPost: multipartRequest('POST', STOCKAPI_URL),
  getBlob: (path, params) => {
    const url = STOCKAPI_URL + path;
    const requestOptions = {
      headers: authHeader(),
      params
      /*     responseType: 'blob'*/
    };
    return axios
      .get(url, requestOptions)
      .then(handleResponse)
      .catch(handleError);
  }
};

export const BrandJwtAxios = {
  get: request('GET', BRAND_API_URL),
  post: request('POST', BRAND_API_URL),
  delete: request('DELETE', BRAND_API_URL),
  put: request('PUT', BRAND_API_URL),
  patch: request('PATCH', BRAND_API_URL),
  download: request('DOWNLOAD', BRAND_API_URL),
  upload: multipartUpload('POST', BRAND_API_URL),
  excelMultiPartGet: multipartRequest('GET', BRAND_API_URL),
  excelMultiPartPost: multipartRequest('POST', BRAND_API_URL)
};

function request(method, baseURL) {
  return (path, body) => {
    let url = baseURL + path;
    const requestOptions = {
      headers: authHeader(),
      responseType: 'json'
    };

    if (method === 'GET' && body) {
      url += '?' + jsonToQuery(body);
    } else if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
      if (body instanceof FormData) {
        delete requestOptions.headers['Content-Type']; // 브라우저가 자동 세팅
      } else if (body !== undefined && body !== null) {
        requestOptions.headers['Content-Type'] = 'application/json;charset=utf-8';
      } else {
        // DELETE 요청에서 body가 없으면 Content-Type 제거
        delete requestOptions.headers['Content-Type'];
      }
    }

    // DELETE 요청에서 body가 없으면 data를 undefined로 설정
    const requestData = (method === 'DELETE' && (body === undefined || body === null)) ? undefined : body;

    // DELETE 요청에서 body가 없을 때는 Authorization 헤더만 포함하고 Content-Type 완전히 제거
    let finalHeaders;
    if (method === 'DELETE' && (body === undefined || body === null)) {
      // Content-Type 없이 Authorization만 포함
      finalHeaders = { ...authHeader() };
      // 명시적으로 Content-Type 제거
      delete finalHeaders['Content-Type'];
      delete finalHeaders['content-type'];
    } else {
      finalHeaders = { ...requestOptions.headers };
    }

    // axios config 생성
    const axiosConfig = {
      method,
      url,
      data: requestData,
      headers: finalHeaders,
      responseType: requestOptions.responseType
    };

    // DELETE 요청에서 body가 없을 때 Content-Type 완전히 제거
    if (method === 'DELETE' && (body === undefined || body === null)) {
      // axios가 자동으로 추가하지 않도록 명시적으로 제거
      delete axiosConfig.headers['Content-Type'];
      delete axiosConfig.headers['content-type'];
      // data도 명시적으로 undefined로 설정
      axiosConfig.data = undefined;
    }

    return axios(axiosConfig)
      .then(response => {
        // 응답 헤더에서 서버 정보 추출 (로드밸런싱 대응)
        const socketUrl = response.headers['x-socket-url'] || response.headers['X-Socket-Url'];
        if (socketUrl) {
          const { useAuthStore } = require('@/stores/auth');
          const authStore = useAuthStore();
          authStore.socketUrl = socketUrl;
          localStorage.setItem('socketUrl', socketUrl);
          console.log('[JwtAxios] 서버에서 Socket URL 수신:', socketUrl);
        }
        return handleResponse(response);
      })
      .catch(handleError);
  };
}

function multipartRequest(method, baseURL) {
  return (path, fd) => {
    let url = baseURL + path;
    const requestOptions = { headers: authHeader() };
    requestOptions.headers['accept'] = 'text/plain';
    requestOptions.headers['Content-Type'] = 'application/json';

    return axios({
      method,
      url,
      data: fd,
      headers: requestOptions.headers,
      responseType: 'blob'
    })
      .then(response => {
        const blob = response.data;
        const disposition = response.headers['content-disposition'];
        let fileName = 'download.xlsx';
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        return blob;
      })
      .catch(async error => {
        const response = error.response;
        if (!response) return { message: '네트워크 오류가 발생했습니다.' };

        if ([401, 403].includes(response.status)) {
          const { logout } = useAuthStore();
          logout();
          return;
        }

        if (response.data instanceof Blob) {
          try {
            const text = await response.data.text();
            const json = JSON.parse(text);
            return { message: json.message || json.Message || '다운로드 중 오류가 발생했습니다.' };
          } catch {
            return { message: '다운로드 중 오류가 발생했습니다.' };
          }
        }
        return response.data;
      });
  };
}

function excelMultiPartGet(baseURL) {
  return (path) => {
    const url = baseURL + path;
    const requestOptions = {
      headers: authHeader()
    };
    requestOptions.headers['accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    requestOptions.headers['Content-Type'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    return axios({
      method: 'GET',
      url: url,
      headers: requestOptions.headers,
      responseType: 'blob'
    })
      .then(handleResponse)
      .catch(handleError);
  };
}

function multipartUpload(method, baseURL) {
  return async (path, fd) => {
    let url = baseURL + path;
    return axios({
      method,
      url,
      data: fd,
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(handleResponse)
      .catch(handleError);
  };
}

function authHeader() {
  let resultModel = {};
  const { accessToken } = useAuthStore();
  if (accessToken) {
    resultModel = { Authorization: `Bearer ${accessToken}` };
  }
  return resultModel;
}

function handleResponse(response) {
  if (response.status !== 200) {
    const { refreshToken, logout } = useAuthStore();
    if ([401, 403].includes(response.status) && refreshToken) {
      logout();
      return;
    }
    const error = (response.data && response.data.message) || response.statusText;
    return Promise.reject(error);
  }
  if (response.config.responseType === 'blob') {
    return response;
  }
  return response.data;
}

function handleError(error) {
  const response = error.response;
  if (!response) return false;

  if ([401, 403].includes(response.status)) {
    const { logout } = useAuthStore();
    logout();
    return;
  }
  return response.data;
}

function jsonToQuery(param) {
  if (typeof param !== 'object') return false;
  return Object.keys(param)
    .map(key => `${key}=${encodeURIComponent(param[key])}`)
    .join('&');
}

export function getApiBaseUrl() {
  return API_URL;
}
